import { CHARGE_TYPE } from '../../../charges/services/charge-helper.service';
import { ORDER_TYPE } from '../../../main/helper/constants/fraud-order-types.constants';
import { Customer } from '../customer/customer.interface';
import { Meta } from '../meta.interface';

export interface Charge {
    _id: string;
    amount: string;
    currency: string;
    customer_id: string;
    company_id: string;
    company_name?: string;
    reference: string;
    reference2?: string;
    reference3?: string;
    fraud_charge_id?: string;
    _3ds_charge_id?: string;
    description: string;
    descriptor: string;
    customer: Customer;
    gateway_mode: string;
    gateway_name: string;
    gateway_type: string;
    created_at: string;
    updated_at: string;
    status: string;
    archived: boolean;
    payment_source_id: string;
    initialization_source: string;
    enable_rejection_rules: boolean;
    first_payment?: boolean;
    transactions: Transaction[];
    meta: Meta;
    custom_fields: { key: string; value: string }[];
    fraud?: {
        service_id: string;
        data?: object;
    };
    type: CHARGE_TYPE;
    card_accept_type?: string;
    card_holder_accept_method?: string;
    bulk_reference?: string;
    terminal_id?: string;
    capture: boolean;
    order_type?: ORDER_TYPE;
}

export interface Transaction {
    fraud: {
        status: string;
    };
    _id?: string;
    external_id?: string;
    amount: number;
    currency: string;
    error_message?: string;
    destination?: string;
    created_at?: string;
    updated_at?: string;
    type: string;
    status?: string;
    gateway_specific_code?: string;
    gateway_specific_description?: string;
    error_code?: string;
    status_code?: string;
    _source_ip_address?: string;
    status_code_description?: string;
    include_authorization?: boolean;
    custom_fields?: Array<{ key: string; value: string }>;
}

export interface Balance {
    amount: number;
}

export enum CARD_ACCEPT_TYPE {
    NORMAL_PRESENTMENT = 'normalPresentment',
    MERCHANT_INITIATED = 'merchantInitiated',
    ELECTRONIC_CASH_REGISTER_INTERFACE = 'electronicCashRegisterInterface',
    CUSTOMER_TERMINAL = 'customerTerminal',
    ADMINISTRATION_TERMINAL = 'administrationTerminal',
    UNATTENDED_TERMINAL = 'unattendedTerminal',
    ELECTRONIC_PAYMENT_TERMINAL = 'electronicPaymentTerminal',
    CARD_ACTIVATED_FUEL_DISPENSER = 'cardActivatedFuelDispenser',
    TRAVEL_TICKET_VENDING_MACHINE = 'travelTicketVendingMachine',
    GENERAL_VENDING_MACHINE = 'generalVendingMachine',
    ELECTRONIC_COMMERCE = 'electronicCommerce',
}
